import { setWhiteboarUrl } from 'store/actions/Whiteboard'

import store from '../index'

const { dispatch } = store

export const dispatchSetWhiteboarUrl = payload =>
    dispatch(setWhiteboarUrl(payload))
